import { useQuery } from '@tanstack/react-query'
import { PlusDesktopSectionItem } from '../../../../../components/landing/event/PlusDesktopSections'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import client from '../../../../../modules/sanityClient'
import { GLOBAL_LANDING_CMS_SECTION_GET_DATA_QUERY } from '../../../../../sanity/groqQueries'
import { GLOBAL_LANDING_CMS_SECTION_GET_DATA_QUERYResult } from '../../../../../sanity/types'

const fetchGlobalLandingData = async () => {
  const post: GLOBAL_LANDING_CMS_SECTION_GET_DATA_QUERYResult = await client.fetch(
    GLOBAL_LANDING_CMS_SECTION_GET_DATA_QUERY
  )
  return post
}

const NewcomerSection = () => {
  const { locale } = useTranslation()
  const { data } = useQuery({ queryKey: ['global_landing', locale], queryFn: () => fetchGlobalLandingData() })
  const sectionArray = data?.[locale]?.webSectionArray || []

  return (
    <div>
      {data &&
        sectionArray?.map((sectionItem, index) => (
          <PlusDesktopSectionItem item={sectionItem} key={sectionItem?._id} index={index} />
        ))}
    </div>
  )
}

export default NewcomerSection
